import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VehicleIpvaLicensingService } from '../../../services/vehicle-ipva-licensing.service';
import { VehicleIpvaLicensingPaymentHistory, VehicleIpvaLicensingRefreshStatusResponse } from '../../../models/VehicleIpvaLicensing';

@Component({
  selector: 'app-vehicle-ipva-licensing-detail',
  templateUrl: './vehicle-ipva-licensing-detail.component.html',
  styleUrls: ['./vehicle-ipva-licensing-detail.component.css']
})
export class VehicleIpvaLicensingDetailComponent implements OnInit {
  id: number | null = null;
  vehicleId: number | null = null;
  item: VehicleIpvaLicensingPaymentHistory | null = null;
  loading = false;
  error: string | null = null;
  refreshing = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ipvaLicensingService: VehicleIpvaLicensingService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const idParam = params.get('id');
      this.id = idParam ? +idParam : null;
      this.vehicleId = params.get('vehicleId') ? +params.get('vehicleId')! : null;
      if (!this.vehicleId && this.route.snapshot.queryParamMap.get('vehicleId')) {
        this.vehicleId = +this.route.snapshot.queryParamMap.get('vehicleId')!;
      }
      if (this.id) {
        this.loadDetail();
      } else {
        this.error = 'Registro não informado.';
      }
    });
  }

  loadDetail(): void {
    if (!this.id) return;
    this.loading = true;
    this.error = null;
    this.ipvaLicensingService.getById(this.id).subscribe({
      next: data => {
        this.item = data;
        this.vehicleId = data.vehicleId;
        this.loading = false;
      },
      error: err => {
        this.error = err?.message || 'Erro ao carregar registro';
        this.loading = false;
      }
    });
  }

  goBack(): void {
    const nav = ['/financial/ipva-licensing'];
    const queryParams = this.vehicleId ? { vehicleId: this.vehicleId } : {};
    this.router.navigate(nav, { queryParams });
  }

  refreshStatus(): void {
    if (!this.id || this.refreshing) return;
    this.refreshing = true;
    this.ipvaLicensingService.refreshStatus(this.id).subscribe({
      next: (res: VehicleIpvaLicensingRefreshStatusResponse) => {
        this.refreshing = false;
        if (res.updated) {
          this.loadDetail();
        }
      },
      error: () => (this.refreshing = false)
    });
  }

  formatCurrency(value: number | null): string {
    if (value == null) return '—';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  }

  formatDate(value: string | null): string {
    if (!value) return '—';
    return new Date(value).toISOString().slice(0, 10);
  }
}
